// extracted by mini-css-extract-plugin
module.exports = {"logo":"RestaurantLogo__logo___30K-O"};